import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface Ipayload {
  userid: string | null,
  fromdate: string,
  todate: string,
  SiteCode: any,
  CafeCode: any,
  //isallsite: boolean,
 // isallcafe: boolean,
  MenuPlanTypeId?: string; 

}

const initialState: any = {
  projectionData: [],
  loading: false,
  error: null,
  cutoffdate: null,
  ismppublished: false
};
interface projectionData {
  daypartmenulist: any;
  cutoffdate: string;
  ismppublished: boolean;
}

export const fetchMenuProjectionSelectionData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchMenuProjectionSelectionData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionSelection/GetMenuProjectionSelection`, payload);
    return response.data.data
  }
);

export const SaveMenuProjectionSelection = createAsyncThunk(
  'MenuProjection/SaveMenuProjectionSelection',
  async (payload: object) => {
    //const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionSelection/SaveMenuProjectionSelection`, payload);
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionSelection/SaveMenuProjectionSelectionAll`, payload);
   
    return response?.data?.data;
  }
);

export const fetchMenuProjectionPlanComboSelection = createAsyncThunk(
  'MenuProjection/fetchInitiateMenuPlanComboSelection',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionSelection/GetMenuProjectionComboSelection`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionnFoodProgramSelection = createAsyncThunk(
  'MenuProjection/fetchMenuProjectionnFoodProgramSelection',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjectionSelection/GetMenuProjectionFoodProgramSelection`, payload);
    return response?.data?.data;
  }
);

export const saveMenuProjectionFoodProgram = createAsyncThunk(
  'MenuProjection/saveMenuProjectionFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/saveMenuProjectionFoodProgram`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionExportData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchMenuProjectionExportData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetMenuProjectionReport`, payload);
    return response.data.data
  }
);


const projectionSelectionDataSlice = createSlice({
  name: 'ProjectionSelectionData',
  initialState,
  reducers: {
    updateProjectionData: (state, action) => {
      state.projectionData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuProjectionSelectionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionSelectionData.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = [...action.payload.daypartmenulist];
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
      })
      .addCase(fetchMenuProjectionSelectionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(SaveMenuProjectionSelection.fulfilled, (state) => {
        state.loading = false;
        // state.projectionData = action.payload.daypartmenulist;
        // state.cutoffdate = action.payload.cutoffdate
      })
      .addCase(SaveMenuProjectionSelection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionPlanComboSelection.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionPlanComboSelection.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
      })
      .addCase(fetchMenuProjectionPlanComboSelection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionnFoodProgramSelection.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionnFoodProgramSelection.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
      })
      .addCase(fetchMenuProjectionnFoodProgramSelection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveMenuProjectionFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveMenuProjectionFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
      })
      .addCase(saveMenuProjectionFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionExportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionExportData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchMenuProjectionExportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { updateProjectionData } = projectionSelectionDataSlice.actions;
export default projectionSelectionDataSlice.reducer;
